import { InputContainer } from "@/components/ui/forms/inputContainer"
import { StandardInput } from "@/components/ui/forms/standardInput"
import { word } from "@modules/core/utils/i18n"
import { ProfileLabelVisibility } from "@modules/profile/myProfile/components/profileLabelVisibility"
import { type ProfileFormTabProps } from "@modules/profile/myProfile/profileFormikType"
import { Text } from "@/components/ui/baseUi/text"

export function AnatomyForm({ isFormFieldInValid, getFormErrorMessage, formik }: ProfileFormTabProps) {
  return (
    <div className="mt-6 flex grow flex-col justify-start gap-8 px-4">
      <Text fontStyle="TM" className="mb-4 self-center">
        {word("profile.form.anatomy.title")}
      </Text>

      {/* Height input */}
      <InputContainer>
        <ProfileLabelVisibility
          label={word("profile.form.height.label")}
          name="height"
          isInvalid={isFormFieldInValid("height")}
          displayVisibleToggle
          visibility={formik.getFieldProps("heightVisibility").value}
          onToggleVisibility={() =>
            formik.setFieldValue("heightVisibility", !formik.getFieldProps("heightVisibility").value)
          }
        />
        <StandardInput
          inputProps={{
            type: "number",
          }}
          setFieldValue={formik.setFieldValue}
          getFieldProps={formik.getFieldProps}
          name="height"
          error={getFormErrorMessage("height")}
          containerClassName="flex-row items-center"
          children={
            <Text fontStyle="LL" className="ml-1 w-8">
              cm
            </Text>
          }
        />
      </InputContainer>

      {/* Weight input */}
      <InputContainer>
        <ProfileLabelVisibility
          label={word("profile.form.weight.label")}
          name="weight"
          isInvalid={isFormFieldInValid("weight")}
          displayVisibleToggle
          visibility={formik.getFieldProps("weightVisibility").value}
          onToggleVisibility={() =>
            formik.setFieldValue("weightVisibility", !formik.getFieldProps("weightVisibility").value)
          }
        />
        <StandardInput
          inputProps={{
            type: "number",
          }}
          setFieldValue={formik.setFieldValue}
          getFieldProps={formik.getFieldProps}
          name="weight"
          error={getFormErrorMessage("weight")}
          containerClassName="flex-row items-center"
          children={
            <Text fontStyle="LL" className="ml-1 w-8">
              kg
            </Text>
          }
        />
      </InputContainer>
    </div>
  )
}
